<template>
  <share-button :entity-type="entityType" :entity-slug="entitySlug" :channel-settings="channelSettings"
                :utm-medium="utmMedium" :share-url-from-url="shareUrlFromUrl" />
</template>

<script>
import ButtonMixin from './button-mixin'

export default {
  mixins: [ButtonMixin],

  methods: {
    shareUrlFromUrl(url) {
      const encodedUrl = encodeURIComponent(url)
      return `https://api.whatsapp.com/send?text=${encodedUrl}`
    }
  }
}
</script>
